<form class="form-for-payment-method-redirect" [name]="formName" [id]="formName" autocomplete="off"
    [formGroup]="formControl" (ngSubmit)="handleFormSubmit($event)" method="post" #form>

    <shared-forms-input [compact]="compact" [disabled]="isMakingRequests$ | async" [parentForm]="formControl"
        name="CardHolderName" [label]="labelCardHolderName" placeholder="E.g John Smith">
    </shared-forms-input>

    <shared-forms-input [compact]="compact" [disabled]="isMakingRequests$ | async" [parentForm]="formControl"
        type="text" pattern="[0-9]*" inputmode="numeric" name="CardNumber" [maxLength]="16" [label]="labelCardNumber"
        placeholder="E.g 400000000000000000">
    </shared-forms-input>

    <shared-forms-columns [mobileFull]="true">
        <div class="form-for-payment-method-redirect__field">
            <shared-forms-input [maxLength]="2" [compact]="compact" [disabled]="isMakingRequests$ | async"
                [parentForm]="formControl" name="ExpiryMonth" [label]="labelExpiryMonth" placeholder="E.g 02"
                type="text" pattern="[0-9]*" inputmode="numeric">
            </shared-forms-input>
        </div>

        <div class="form-for-payment-method-redirect__field">
            <shared-forms-input [maxLength]="2" [compact]="compact" [disabled]="isMakingRequests$ | async"
                [parentForm]="formControl" name="ExpiryYear" [label]="labelExpiryYear" placeholder="E.g 24" type="text"
                pattern="[0-9]*" inputmode="numeric">
            </shared-forms-input>
        </div>
    </shared-forms-columns>

    <shared-forms-columns [mobileFull]="true">
        <div class="form-for-payment-method-redirect__field">
            <shared-forms-input [maxLength]="4" [compact]="compact" [disabled]="isMakingRequests$ | async"
                [parentForm]="formControl" name="Cvc2" [label]="labelCVV" placeholder="E.g 1234" type="text"
                pattern="[0-9]*" inputmode="numeric">
            </shared-forms-input>
        </div>
    </shared-forms-columns>

    <shared-forms-input *ngIf="guest === false" [compact]="compact" [parentForm]="formControl" name="saveCard"
        [required]="false" [label]="labelSaveCard" type="checkbox">
    </shared-forms-input>

    <ng-template #actions>
        <shared-forms-columns align="start" [itemsMargin]="true">
            <shared-forms-submit [loading]="isMakingRequests$ | async" [width]="buttonWidth" [size]="buttonSize"
                [parentForm]="formControl" [marginTop]="modal ? null : 'md'">{{labelSubmit}}</shared-forms-submit>

            <shared-forms-submit [disabled]="isMakingRequests$ | async"
                *ngIf="((canCancelForm$ | async) && allowCancel) && allowCancel" feel="secondary" type="button"
                [width]="buttonWidth" [size]="buttonSize" (onClick)="handleFormCancel($event)">
                {{labelCancel}}</shared-forms-submit>
        </shared-forms-columns>
    </ng-template>

    <shared-forms-offset-wrapper *ngIf="modal" [topOffset]="false" [modalOffset]="modal" [right]="actions">
    </shared-forms-offset-wrapper>

    <ng-container *ngIf="!modal">
        <ng-container *ngTemplateOutlet="actions"></ng-container>
    </ng-container>


</form>
